






























import Vue from 'vue';

const pickupIcon = require('@/assets/stop_icons/pickup.svg') as string;
const dropoffIcon = require('@/assets/stop_icons/dropoff.svg') as string;

export default Vue.extend({
    name: 'OfficesMap',
    props: {
        stops: {
            type: Array,
        },
    },
    data() {
        return {
            center: { lat: 0, lng: 0 } as object,
            stopsLocations: [] as Array<object>,
            mapOptions: {
                zoomControl: true,
                mapTypeControl: true,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: true,
                disableDefaultUi: false,
            },
            infoWindowPos: null,
            infoWinOpen: false,
            infoOptions: {
                content: '',
                // optional: offset infowindow so it visually sits nicely on top of our marker
                pixelOffset: {
                    width: 0,
                    height: -35,
                },
            },
            currentMidx: null,
        };
    },
    watch: {
        stops: {
            deep: true,
            handler() {
                // @ts-ignore
                this.$refs.gmap.$mapPromise.then(() => {
                    this.updateLocations();
                });
            },
        },
    },
    methods: {
        updateLocations() {
            this.infoWinOpen = false;
            this.stopsLocations = [];
            if (this.stops.length > 0) {
                this.center = {
                    lat: Number((this.stops[0] as any).pickupStopLat),
                    lng: Number((this.stops[0] as any).pickupStopLong),
                };
                this.stops.forEach((stop: any) => {
                    const pickupLat = stop?.pickupStopLat;
                    const pickupLong = stop?.pickupStopLong;
                    if (pickupLat && pickupLong) {
                        this.addLocation(
                            pickupLat,
                            pickupLong,
                            stop.pickupStopName,
                            pickupIcon,
                        );
                    }
                    const dropoffStopLat = stop?.dropoffStopLat;
                    const dropoffStopLong = stop?.dropoffStopLong;
                    if (dropoffStopLat && dropoffStopLong) {
                        this.addLocation(
                            dropoffStopLat,
                            dropoffStopLong,
                            stop.dropoffStopName,
                            dropoffIcon,
                        );
                    }
                });
            }
        },
        addLocation(
            lat: string,
            lng: string,
            stopName: string,
            icon: string,
        ): void {
            const marker = {
                lat: Number(lat),
                lng: Number(lng),
            };
            this.stopsLocations.push({
                position: marker,
                infoText: `<p>${stopName}</p>`,
                marker: {
                    icon: {
                        url: icon,
                        labelOrigin: { x: 20, y: -3 },
                        // @ts-ignore
                        // eslint-disable-next-line
                        scaledSize: new google.maps.Size(40, 40),
                    },
                },
            });
        },
        toggleInfoWindow(marker: any, idx: any) {
            this.infoWindowPos = marker.position;
            this.infoOptions.content = marker.infoText;

            // check if its the same marker that was selected if yes toggle
            if (this.currentMidx === idx) {
                this.infoWinOpen = !this.infoWinOpen;
            } else {
                // if different marker set infowindow to open and reset current marker index
                this.infoWinOpen = true;
                this.currentMidx = idx;
            }
        },
    },
    mounted() {
        // @ts-ignore
        this.$refs.gmap.$mapPromise.then(() => {
            this.updateLocations();
        });
    },
});
